import PropTypes from 'prop-types';

import Label from 'src/components/label';

// Marcador do plano no menu e nos avisos (ex.: "5.0" = indústria 5.0).
export default function PlanBadge({ plan = '5.0', sx }) {
  return (
    <Label variant="filled" color="success" sx={{ height: 20, px: 0.75, fontSize: 11, ...sx }}>
      {plan}
    </Label>
  );
}

PlanBadge.propTypes = {
  plan: PropTypes.string,
  sx: PropTypes.object,
};
